import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m31.542 32.577-6.28-6.281c-.5.413-1.075.736-1.725.97-.65.233-1.323.35-2.018.35-1.709 0-3.155-.593-4.34-1.776-1.183-1.183-1.775-2.63-1.775-4.338 0-1.71.592-3.156 1.775-4.34 1.184-1.185 2.63-1.777 4.339-1.777 1.709 0 3.155.592 4.34 1.775 1.184 1.184 1.777 2.63 1.777 4.34a5.87 5.87 0 0 1-.36 2.046c-.24.65-.56 1.216-.96 1.696l6.281 6.281zM21.52 26.116c1.289 0 2.38-.448 3.274-1.342.895-.894 1.342-1.986 1.342-3.274s-.447-2.38-1.342-3.274c-.894-.894-1.985-1.341-3.274-1.341-1.288 0-2.38.447-3.274 1.341-.894.894-1.341 1.986-1.341 3.274s.447 2.38 1.341 3.274c.895.894 1.986 1.341 3.274 1.341Zm-.75-1.924V22.25h-1.942v-1.5h1.942v-1.942h1.5v1.942h1.943v1.5H22.27v1.942z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M24 46.5c12.426 0 22.5-10.074 22.5-22.5S36.426 1.5 24 1.5 1.5 11.574 1.5 24 11.574 46.5 24 46.5m0 1.5c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }